import { HttpContextToken } from "@angular/common/http";

export const IGNORE_401 = new HttpContextToken<boolean>(() => false);
